import * as Yup from 'yup';
export const initialAttendenceReasonValues = {
    reason: '',
};
export const attendenceReasonSchema = Yup.object().shape({
    reason: Yup.string(),
});
//# sourceMappingURL=programme-attendance-reason.js.map